export const decodeProjectEnvironmentalCommitment = (entity) => ({
    category: entity.category,
    created: new Date(entity.created),
    ...(entity.emission_factor_type != null
        ? { emissionFactorType: entity.emission_factor_type }
        : {}),
    ...(entity.generation_source != null
        ? { generationSource: entity.generation_source }
        : {}),
    id: entity.project_environmental_commitment_id,
    metricType: entity.metric_type,
    projectId: entity.project_id,
    ...(entity.source_framework_id != null
        ? { sourceFrameworkId: entity.source_framework_id }
        : {}),
    ...(entity.source_framework_target_id != null
        ? { sourceFrameworkTargetId: entity.source_framework_target_id }
        : {}),
    subCategory: entity.sub_category,
    ...(entity.sub_category_description != null
        ? { subCategoryDescription: entity.sub_category_description }
        : {}),
    targetType: entity.target_type
});
export const encodeProjectEnvironmentalCommitment = (lineItem) => ({
    category: lineItem.category,
    created: lineItem.created,
    ...(lineItem.emissionFactorType != null
        ? { emission_factor_type: lineItem.emissionFactorType }
        : {}),
    ...(lineItem.generationSource != null
        ? { generation_source: lineItem.generationSource }
        : {}),
    metric_type: lineItem.metricType,
    project_environmental_commitment_id: lineItem.id,
    project_id: lineItem.projectId,
    ...(lineItem.sourceFrameworkId != null
        ? { source_framework_id: lineItem.sourceFrameworkId }
        : {}),
    ...(lineItem.sourceFrameworkTargetId != null
        ? { source_framework_target_id: lineItem.sourceFrameworkTargetId }
        : {}),
    sub_category: lineItem.subCategory,
    ...(lineItem.subCategoryDescription != null
        ? { sub_category_description: lineItem.subCategoryDescription }
        : {}),
    target_type: lineItem.targetType
});
export const decodePackageEnvironmentalCommitment = (entity) => ({
    contractorPackageId: entity.contractor_package_id,
    created: new Date(entity.created),
    id: entity.package_environmental_commitment_id,
    projectEnvironmentalCommitmentId: entity.project_environmental_commitment_id,
    projectId: entity.project_id
});
export const encodePackageEnvironmentalCommitment = (lineItem) => ({
    contractor_package_id: lineItem.contractorPackageId,
    created: lineItem.created,
    package_environmental_commitment_id: lineItem.id,
    project_environmental_commitment_id: lineItem.projectEnvironmentalCommitmentId,
    project_id: lineItem.projectId
});
